import React from "react";
import { Grid, Box, Heading, Text } from "@chakra-ui/core";
import { ImageBox } from "@engyalo/storefront-components";
import { ICollectionProduct } from "@engyalo/storefront-types";

export function HorizontalProduct({
  product,
  currency,
  currencyPrefix,
  cart,
  showPrice,
  ...props
}: ICollectionProduct) {
  const quantity = Object.entries(cart).reduce(
    (prev, [key, cartItem]) =>
      key.includes(product.id ?? "") ? prev + (cartItem?.quantity ?? 0) : prev,
    0
  );
  console.log(`Product: ${product.id}: ${quantity}`, cart);
  return (
    <Grid gridTemplateColumns="1fr 3fr" borderY="1px solid #F1F1F1" py="10px">
      <Box>
        <ImageBox
          imageUrl={(product.imageURL || [])[0] || ""}
          quantity={quantity}
        />
      </Box>
      <Box ml="8">
        <Heading as="h3" size="sm">
          {product.name}
        </Heading>
        <Text fontFamily="body" color="gray.100" my="2">
          {product.description}
        </Text>
        {showPrice && (
          <Text fontFamily="body" fontSize="md" color="primary.500">
            {`${currencyPrefix} ${product.price} ${currency}`}
          </Text>
        )}
      </Box>
    </Grid>
  );
}
